import { createBasicSelector } from 'util/redux'
import selectIntegrationsById from './selectIntegrationsById'

export default createBasicSelector(
  selectIntegrationsById,
  (state, integrationId) => integrationId,
  (byId, integrationId) => byId[integrationId]
)
